// Polyfills for Solana Web3.js compatibility
import { Buffer } from 'buffer';

window.Buffer = Buffer;